// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"eb3068d2","359":"a730f997","447":"1974b36e","587":"5e3e4eb3","629":"261957ae","891":"88376cd6","937":"873e8511"}[chunkId] + ".chunk.js";
};